{
  "name": "management",
  "version": "1.111.1",
  "type": "module",
  "private": true,
  "author": "Albacross",
  "license": "UNLICENSED",
  "engines": {
    "node": ">=24.0.0",
    "pnpm": ">=11.0.0"
  },
  "dependencies": {
    "@albacross/frontend-utils": "workspace:*",
    "@albacross/static-data": "workspace:*",
    "@albacross/types": "workspace:*",
    "@bugsnag/js": "catalog:",
    "@bugsnag/plugin-react": "catalog:",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@microlink/react-json-view": "^1.31.24",
    "@mui/icons-material": "^9.3.1",
    "@mui/material": "^9.3.1",
    "@mui/x-date-pickers": "^9.10.1",
    "classnames": "catalog:",
    "copy-to-clipboard": "catalog:",
    "date-fns": "catalog:",
    "immutable": "catalog:",
    "lodash": "catalog:",
    "notistack": "^3.0.2",
    "query-string": "catalog:",
    "react": "catalog:",
    "react-csv-reader": "^4.0.0",
    "react-dom": "catalog:",
    "react-dropzone": "catalog:",
    "react-hook-form": "catalog:",
    "@tanstack/react-query": "catalog:",
    "react-redux": "catalog:",
    "react-router": "catalog:",
    "react-router-dom": "catalog:",
    "recharts": "catalog:",
    "redux": "catalog:",
    "redux-actions": "catalog:",
    "redux-catch": "catalog:",
    "redux-thunk": "catalog:",
    "reselect": "catalog:"
  },
  "devDependencies": {
    "@hookform/devtools": "catalog:",
    "@testing-library/dom": "catalog:",
    "@testing-library/react": "catalog:",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "catalog:",
    "autoprefixer": "^10.4.20",
    "jsdom": "catalog:",
    "redux-mock-store": "^1.5.3",
    "sass": "catalog:",
    "vite": "catalog:",
    "@types/lodash": "catalog:"
  }
}
